module.exports = __webpack_public_path__ + "img/corenrj.34f001fc.jpg";